<div class="dropzone" appDropAndDrag (fileDropped)="onFileDropped($event)">
  <input [accept]="accept" type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
  <span class="icon-upload">
    <i class="fas fa-cloud-upload-alt"></i>
  </span>
  <h3>Drag and drop</h3>
  <h3>o</h3>
  <label for="fileDropRef">Busca Archivos</label>
</div>
<div class="files-list">
  @if (showTable) {
    <div class="files-list__inner px-3">
      <table class="table-borderless files-list__table">
        <thead>
          <tr class="row mx-0">
            <th [class]="enableCategory ? 'col-md-3' : 'col-md-5'">Archivo</th>
            <th class="col-md-1"></th>
            @if (enableCategory) {
              <th class="col-md-4">Categoría <span class="text-danger">*</span></th>
            }
            @if (!hideNoteField) {
              <th [class]="enableCategory ? 'col-md-4' : 'col-md-6'">Nota</th>
            }
          </tr>
        </thead>
        @for (file of files; track file; let i = $index) {
          <tbody>
            <tr class="row mx-0 align-items-center">
              <td class="text-table" [class]="enableCategory ? 'col-md-3' : 'col-md-5'">
                <div class="file-name text-truncate" [title]="file.name">{{file.name}}</div>
                <div class="file-size">{{ formatFileSize(file.size) }}</div>
              </td>
              <td class="col-md-1">
                <a type="button" class="icon-table" (click)="deleteFile(i)"><i class="far fa-trash-alt"></i></a>
              </td>
              @if (enableCategory) {
                <td class="col-md-4">
                  <select
                    class="form-control style-asunto"
                    [name]="'category-' + i"
                    [(ngModel)]="file.category"
                    (ngModelChange)="onCategoryChange(file)"
                    required
                    >
                    <option [ngValue]="''" disabled>Seleccione categoría</option>
                    @for (opt of categories; track opt.id) {
                      <option [ngValue]="opt.id">{{ opt.name }}</option>
                    }
                  </select>
                </td>
              }
              <td [class]="enableCategory ? 'col-md-4' : 'col-md-6'">
                @if (!hideNoteField) {
                  <input
                    type="text"
                    class="form-control style-asunto"
                    #noteValueRef
                    [name]="'note-' + i"
                    placeholder="Comentario opcional"
                    [(ngModel)]="file.note"
                    >
                }
              </td>
            </tr>
            @if (enableCategory && file.category === 'otro') {
              <tr class="row mx-0 align-items-center category-other-row">
                <td class="col-md-4 offset-md-4">
                  <label class="category-other-label">Nombre de la categoría <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control style-asunto"
                    [name]="'categoryother-' + i"
                    placeholder="Nombre de la categoría"
                    [(ngModel)]="file.categoryother"
                    (ngModelChange)="emitFiles()"
                    required
                    >
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
      <div class="files-total mt-2">
        Total a subir: <strong>{{ formatFileSize(totalBytes) }}</strong>
        @if (files.length > 1) {
          <span class="files-total-count">({{ files.length }} archivos)</span>
        }
      </div>
    </div>
  }
  @if (successMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }
  @if (errorMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert  class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }
</div>
